const footerColumns = [
  {
    title: "浏览",
    links: [
      { label: "实时快讯流", href: "#feed" },
      { label: "今日新料", href: "#today" },
      { label: "追新热榜", href: "#hot" },
      { label: "专题索引", href: "#topics" },
    ],
  },
  {
    title: "说明",
    links: [
      { label: "为什么可信", href: "#trust" },
      { label: "常见问题", href: "#faq" },
      { label: "可信度标注规则", href: "#trust" },
      { label: "来源与核实", href: "#faq" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-10 pt-12 md:pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                爱
              </span>
              <span className="font-heading text-xl font-bold">爱黑料网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              今日更新速递，全网黑料实时同步。我们把快讯、最快黑料与热榜放在同一页，
              帮你用最少的时间追到最新的料。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-2 rounded-full bg-secondary-800 text-secondary-100 text-xs">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-soft" />
              今日更新通道正常 · 实时同步中
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title} className="md:col-span-3">
              <h4 className="font-heading text-sm font-bold text-secondary-100">{col.title}</h4>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-200 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1" />
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-secondary-300">
            © 2026 爱黑料网 · 内容为演示用途，可信度标注以站内说明为准。
          </p>
          <p className="text-xs text-secondary-300">
            爱黑料网最新 · 今日更新 · 实时追新料
          </p>
        </div>
      </div>
    </footer>
  );
}